<template>
  <div class="news page">
    <div class="news-list">
      <div class="item" v-for="item in news" :key="item.id">
        <div class="title">{{item.title}}</div>
        <div class="content" v-if="item.content">{{item.content}}</div>
        <div class="date">{{item.date}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as newsService from '../services/news.service'

  export default {
    name: 'News',
    data () {
      return {
        loading: false,
        news: []
      }
    },

    methods: {
      fetchData () {
        this.loading = true
        newsService.getList()
          .then(response => {
            this.news = response.data
          }).catch((error) => console.log(error))
          .finally(() => { this.loading = false })
      }
    },

    created () {
      this.fetchData()
    }
  }
</script>

<style lang="scss" scoped>
  .news.page .news-list{
    padding: 30px;

    .item {
      padding: 20px;
      background-color: $color-gray-middle;
      margin-bottom: 10px;

      .title {
        font-size: 22px;
        text-transform: uppercase;
        padding-bottom: 10px;
        font-family: $font-title;
      }
      .content {
        padding-bottom: 10px;
      }
      .date {
        font-size: 12px;
        opacity: .5;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/News.vue